import { render } from "./RiProdcategory29.vue?vue&type=template&id=0b54fd69"
import script from "./RiProdcategory29.vue?vue&type=script&lang=js"
export * from "./RiProdcategory29.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdcategory29.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b54fd69"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b54fd69', __exports__)) {
    api.reload('0b54fd69', __exports__)
  }
  
  module.hot.accept("./RiProdcategory29.vue?vue&type=template&id=0b54fd69", () => {
    api.rerender('0b54fd69', render)
  })

}


export default __exports__